import uniq from 'lodash/uniq';
import { usePartnershipsQueriesByIds, useProjectSharesList } from '@round/creatorbase-helpers/api-hooks';

const LINKED_PROJECTS_PAGE_SIZE = 100;

export default function useLinkedProjectsPopoutData(projectId: number) {
    const { data: sharesData, isLoading: areSharesLoading } = useProjectSharesList({
        container_id: projectId,
        page_size: LINKED_PROJECTS_PAGE_SIZE,
    });
    const shares = sharesData?.results ?? [];

    const { partnerships, arePartnershipsLoading } = usePartnershipsQueriesByIds(
        [uniq(shares.map((share) => share.partnership_id))],
        {
            combine: (queries) => ({
                partnerships: queries.flatMap((query) => query.data?.results ?? []),
                arePartnershipsLoading: queries.some((query) => query.isLoading),
            }),
        }
    );

    return { shares, areSharesLoading, partnerships, arePartnershipsLoading };
}
